import { render, staticRenderFns } from "./WorkPerformed.vue?vue&type=template&id=5f064052"
import script from "./WorkPerformed.vue?vue&type=script&lang=js"
export * from "./WorkPerformed.vue?vue&type=script&lang=js"
import style0 from "./WorkPerformed.vue?vue&type=style&index=0&id=5f064052&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports